import axios from "../axios";

export const getTeacherInfo = async(id) => {
   
   const {data} = await axios.get(`teachers/${id}`)
  
   return data
}